import { Receipt, ReceiptFilters } from "../../../models/Receipt";
import { TriplePPagination } from "../TriplePInterface";

export const getReceipt = (data: any): Receipt => {
  const a = data.attributes;
  return {
    id: data.id,
    userId: a.user_id || "",
    userName: a.user_name || "",
    receiptType: a.receipt_type,
    vehicleId: a.vehicle_id != null ? a.vehicle_id : null,
    vehicleLabel: a.vehicle_label || "",
    receiptS3Location: a.receipt_s3_location || "",
    cost: a.cost != null ? Number(a.cost) : null,
    receiptDate: a.receipt_date != null ? a.receipt_date : null,
    vendor: a.vendor || "",
    note: a.note || "",
    extractionStatus: a.extraction_status || "",
    extractionConfidence:
      a.extraction_confidence != null ? Number(a.extraction_confidence) : null,
    createdAt: a.created_at || "",
    updatedAt: a.updated_at || "",
  };
};

export const getReceipts = (data: any): Receipt[] => {
  return data.map(getReceipt);
};

export const buildReceiptParams = (
  filters: ReceiptFilters,
  pagination?: TriplePPagination
): URLSearchParams => {
  const params = new URLSearchParams();
  if (pagination) {
    params.append("count", pagination.count + "");
    params.append("offset", pagination.offset + "");
  }

  if (filters.userId) {
    params.append("user_id", filters.userId);
  }
  if (filters.vehicleId) {
    params.append("vehicle_id", filters.vehicleId);
  }
  if (filters.receiptType) {
    params.append("receipt_type", filters.receiptType);
  }
  if (filters.startDate) {
    params.append("start", filters.startDate.toISOString());
  }
  if (filters.endDate) {
    params.append("end", filters.endDate.toISOString());
  }

  return params;
};
